import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from 'app/core/components/page-header/page-header.component';
import { HasUnsavedChanges } from 'app/core/guards/unsaved-changes.guard';
import { StatusFlowEditorComponent } from '../../components/status-flow-editor/status-flow-editor.component';

@Component({
  selector: 'app-status-flow-management',
  standalone: true,
  imports: [CommonModule, PageHeaderComponent, StatusFlowEditorComponent],
  templateUrl: './status-flow-management.component.html',
  styleUrl: './status-flow-management.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class StatusFlowManagementComponent implements HasUnsavedChanges {
  @ViewChild(StatusFlowEditorComponent) editor?: StatusFlowEditorComponent;

  processTitle(): string {
    return this.editor?.selectedProcess?.name || 'Editar flujo';
  }

  closeEditor(): void {
    this.editor?.closeEditor();
  }

  hasUnsavedChanges(): boolean {
    return this.editor?.hasUnsavedChanges() ?? false;
  }

  confirmDiscardChanges(): boolean | Promise<boolean> {
    return this.editor?.confirmDiscardChanges() ?? true;
  }
}
